export default function (value) {
  return value.toString(16);
}
